import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import SalesProposalAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/SalesProposalAppIcon';

import SalesProposalButton from '../OtherComponents/SalesProposalButton';

const SalesProposalStrategy = {
  previewInfo: {
    name: 'Sales proposal tool',
    iconSvg: <SalesProposalAppIcon size="xlarge" />,
    newTab: false,
  },
  headerInfo: {
    name: 'Sales proposal tool',
    category: 'Create and present Good, Better, Best proposals to close bigger deals',
    details: (
      <div>
        87% of homeowners prefer to see multiple options for services. With Housecall Pro’s Sales Proposal Tool, you can
        quickly build good, better, best presentations in real-time to close larger jobs faster, while providing the
        right solution for your customers. Sales Proposals provide a visually optimized experience, complete with
        pictures and descriptions of your services so you can offer exceptional service by putting your customers in the
        driver’s seat. Stand out from the competition, close more deals, and easily sell larger jobs.
        <br /> <br />
      </div>
    ),
    iconSvg: <SalesProposalAppIcon size="xlarge" />,
  },
  sellingPoints: {
    headline: 'Win more business with our Sales Proposal Tool',
    description: '',
    unorderedPoints: [
      'Quickly create and present visually optimized, side-by-side service options from either the <a href="https://help.housecallpro.com/en/articles/7834730-sales-proposal-tool-2-0-on-web">web</a> or <a href="https://help.housecallpro.com/en/articles/7834798-sales-proposal-tool-2-0-on-mobile">mobile</a> apps directly from an estimate.',
      'Proposals provide multiple options with detailed work descriptions and photos that land higher-value jobs, and drive upsells.',
      'Provide exceptional customer service by giving customers the best opportunity to make informed decisions.',
      'Streamline workflows with fully integrated functionality between the proposal, scheduling, and dispatching process.',
    ],
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/lth2xlvmqw?videoFoam=true',
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Housecall Pro Add-on Price',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={6}>
          <Typography align="left" variant="body1" color="textSecondary">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $40/month
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1" color="textSecondary">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $40/month
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1" color="textSecondary">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $0/month
          </Typography>
        </Grid>
      </Grid>
    ),
    hideToggle: true,
    appActionButton: <SalesProposalButton />,
  },
  supportContacts: [],
};

export default SalesProposalStrategy;
